import { AddItemButton } from '@core/components/Buttons';
import { CurrencyTextField, ReadOnlyInput } from '@core/components/Inputs';
import { Divider, Grid, IconButton, InputLabel, makeStyles, Tooltip } from '@material-ui/core';
import { SelectServico } from 'app/components/Select';
import RetencaoAliquotaModal from 'app/main/servico/components/modal/Retencoes/RetencaoAliquotaModal';
import { calcularValorLiquidoComRetencoes } from 'app/main/venda/utils/retencaoLiquidoUtils';
import * as Actions from 'app/store/actions';
import { getCurrency } from 'app/utils/monetarioUtil';
import { FieldArray, useFormikContext } from 'formik';
import React, { Fragment } from 'react';
import { MdHighlightOff, MdSettings } from 'react-icons/md';
import { useDispatch } from 'react-redux';

const styles = makeStyles({
  diferencaParcelas: {
    fontSize: 15,
    fontWeight: 500,
    color: '#f00',
  },
  buttonAdicionarCategoria: {
    paddingTop: '0px !important',
    paddingLeft: '4px !important',
  },
  buttonRemoveContainer: {
    display: 'flex',
    justifyContent: 'center',
  },
  divider: {
    backgroundColor: 'rgba(0, 0, 0, 0.50)',
  },
});

const Servicos = ({
  servicos = [{ id: undefined, servico: {}, servicoFiscal: {} }],
  handleChange,
  handleBlur,
  disabled,
  indexServicoSelecionado,
  handlerRetencaoAliquota,
  modalRetencaoAliquota,
  setModalRetencaoAliquota,
  errors,
  limitarServicos = false,
}) => {
  const formik = useFormikContext();
  const classes = styles();

  const handleAdicionarServico = (servicos) => {
    const event = {
      target: {
        id: `servicos[${servicos.length}]`,
        value: {},
      },
    };

    handleChange(event);
  };

  const dispatch = useDispatch();
  const showError = (message) => {
    dispatch(Actions.showMessage({ message, variant: 'error' }));
  };

  const validarRetencoesValor = (itemServico, servicoFiscal) => {
    const valorVenda = itemServico?.servico?.valorVenda;

    let somatorio = 0;

    if (servicoFiscal?.tipoIss === 'VALOR' && servicoFiscal?.issRetidoNaFonte) {
      somatorio += servicoFiscal?.valorIss;
    }

    if (servicoFiscal?.tipoIrrf === 'VALOR' && servicoFiscal?.irrfRetidoNaFonte) {
      somatorio += servicoFiscal?.valorIrrf;
    }

    if (servicoFiscal?.tipoPis === 'VALOR' && servicoFiscal?.pisRetidoNaFonte) {
      somatorio += servicoFiscal?.valorPis;
    }

    if (servicoFiscal?.tipoCofins === 'VALOR' && servicoFiscal?.cofinsRetidoNaFonte) {
      somatorio += servicoFiscal?.valorCofins;
    }

    if (servicoFiscal?.tipoInss === 'VALOR' && servicoFiscal?.inssRetidoNaFonte) {
      somatorio += servicoFiscal?.valorInss;
    }

    if (servicoFiscal?.tipoCsll === 'VALOR' && servicoFiscal?.csllRetidoNaFonte) {
      somatorio += servicoFiscal?.valorCsll;
    }

    const diferenca = valorVenda - somatorio;

    if (diferenca < 0) {
      showError('A soma das retenções nominais não podem ultrapassar o valor de venda do serviço.');
      return false;
    }

    return true;
  };

  const validarRetencoesPercentual = (servicoFiscal) => {
    let somatorio = 0;

    if (servicoFiscal?.tipoIss === 'PERCENTUAL' && servicoFiscal?.issRetidoNaFonte) {
      somatorio += servicoFiscal?.valorIss;
    }

    if (servicoFiscal?.tipoIrrf === 'PERCENTUAL' && servicoFiscal?.irrfRetidoNaFonte) {
      somatorio += servicoFiscal?.valorIrrf;
    }

    if (servicoFiscal?.tipoPis === 'PERCENTUAL' && servicoFiscal?.pisRetidoNaFonte) {
      somatorio += servicoFiscal?.valorPis;
    }

    if (servicoFiscal?.tipoCofins === 'PERCENTUAL' && servicoFiscal?.cofinsRetidoNaFonte) {
      somatorio += servicoFiscal?.valorCofins;
    }

    if (servicoFiscal?.tipoInss === 'PERCENTUAL' && servicoFiscal?.inssRetidoNaFonte) {
      somatorio += servicoFiscal?.valorInss;
    }

    if (servicoFiscal?.tipoCsll === 'PERCENTUAL' && servicoFiscal?.csllRetidoNaFonte) {
      somatorio += servicoFiscal?.valorCsll;
    }

    if (somatorio > 100) {
      showError('A soma das retenções do tipo percentual não podem ultrapassar 100%.');
      return false;
    }

    return true;
  };

  const handlerSubmitRetencaoAliquota = (servicoFiscal) => {
    const isUtilizadoIbsCbs =
      servicoFiscal?.cstSituacaoTributaria?.id ||
      servicoFiscal?.cstClassificacaoTributaria?.id ||
      servicoFiscal?.valorIbs > 0 ||
      servicoFiscal?.valorIbsMunicipal > 0 ||
      servicoFiscal?.valorCbs > 0 ||
      servicoFiscal?.valorIs > 0;

    servicoFiscal.possuiIbsCbs = !!isUtilizadoIbsCbs;

    const isValidadoRetencoesPercentual = validarRetencoesPercentual(servicoFiscal);
    const isValidadoRetencoesValor = isValidadoRetencoesPercentual
      ? validarRetencoesValor(servicos[indexServicoSelecionado], servicoFiscal)
      : false;

    if (isValidadoRetencoesPercentual && isValidadoRetencoesValor) {
      if (servicos[indexServicoSelecionado].servicoFiscal?.id) {
        servicos[indexServicoSelecionado].servicoFiscal = Object.assign(
          { id: servicos[indexServicoSelecionado].servicoFiscal?.id },
          servicoFiscal
        );
      } else {
        servicos[indexServicoSelecionado].servicoFiscal = Object.assign({}, servicoFiscal);
        servicos[indexServicoSelecionado].servicoFiscal.id = null;
      }

      setModalRetencaoAliquota('');
    }
  };

  const getSubTotal = (valor, servicoFiscal) => {
    if (valor == null || valor === '') {
      return '-';
    }
    return getCurrency(calcularValorLiquidoComRetencoes(valor, servicoFiscal));
  };

  return (
    <>
      <Grid item xs={12} style={{ display: 'flex', flexDirection: 'row' }}>
        <Grid item xs={6}>
          <InputLabel id="situacao">Nome do serviço *</InputLabel>
        </Grid>
        <Grid item xs={2} style={{ paddingLeft: 15 }}>
          <InputLabel id="situacao">Valor (R$) *</InputLabel>
        </Grid>
        <Grid item xs={2} style={{ paddingLeft: 15 }}>
          <InputLabel id="situacao">Subtotal (R$)</InputLabel>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <Divider style={{ backgroundColor: 'rgba(0, 0, 0, 0.50)' }} />
      </Grid>

      <FieldArray name="servicos">
        {(arrayHelpers) =>
          servicos.map((itemServico, index) => {
            return (
              <Fragment key={index}>
                <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
                  <SelectServico
                    id={`servicos[${index}].servico`}
                    name={`servicos[${index}].servico`}
                    onChange={(e) => {
                      handleChange(e, index);

                      formik.setFieldValue(`servicos[${index}].valor`, e.target.value.valorVenda);
                      formik.setFieldValue(`servicos[${index}].subtotal`, e.target.value.valorVenda);
                    }}
                    onBlur={handleBlur}
                    value={itemServico?.servico}
                    required
                    disableClearable
                    error={errors?.servicos && errors?.servicos[index]?.servico}
                    touched={!!errors?.servicos && !!errors?.servicos[index]?.servico}
                    disabled={disabled}
                  />
                </Grid>
                <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>
                  <CurrencyTextField
                    id={`servicos[${index}].valor`}
                    name={`servicos[${index}].valor`}
                    value={itemServico?.valor}
                    outputFormat="number"
                    currencySymbol=""
                    decimalCharacter=","
                    digitGroupSeparator="."
                    onChange={(e, value) => {
                      formik.setFieldValue(`servicos[${index}].valor`, value);
                      formik.setFieldValue(`servicos[${index}].subtotal`, value);
                    }}
                    maximumValue="999999999"
                    minimumValue="0"
                    decimalPlaces={3}
                    decimalPlacesShownOnBlur={3}
                    decimalPlacesShownOnFocus={3}
                    onBlur={handleBlur}
                    fullWidth
                    required
                    variant="outlined"
                    error={errors?.servicos && errors?.servicos[index]?.valor}
                    helperText={errors?.servicos && errors?.servicos[index]?.valor}
                    touched={!!errors?.servicos && !!errors?.servicos[index]?.valor}
                  />
                </Grid>

                <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>
                  {itemServico.servicoFiscal?.issRetidoNaFonte ||
                  itemServico.servicoFiscal?.pisRetidoNaFonte ||
                  itemServico.servicoFiscal?.cofinsRetidoNaFonte ||
                  itemServico.servicoFiscal?.inssRetidoNaFonte ||
                  itemServico.servicoFiscal?.irrfRetidoNaFonte ||
                  itemServico.servicoFiscal?.csllRetidoNaFonte ? (
                    <Tooltip
                      title="Valor final considerando as retenções do serviço pelo cliente"
                      placement="bottom-end"
                    >
                      <div>
                        <ReadOnlyInput
                          id={`servicos[${index}].subtotal`}
                          value={getSubTotal(itemServico.valor, itemServico.servicoFiscal)}
                        />
                      </div>
                    </Tooltip>
                  ) : (
                    <div>
                      <ReadOnlyInput
                        id={`servicos[${index}].subtotal`}
                        value={getSubTotal(itemServico.valor, itemServico.servicoFiscal)}
                      />
                    </div>
                  )}
                </Grid>

                {itemServico?.servico?.id && (
                  <Grid item xs={1} style={{ display: 'flex', justifyContent: 'center' }}>
                    <Tooltip title="Atualizar alíquotas" placement="right-end">
                      <Grid item style={{ justifyContent: 'center', alignContent: 'center' }}>
                        <IconButton onClick={() => handlerRetencaoAliquota(index)}>
                          <MdSettings size={18} />
                        </IconButton>
                      </Grid>
                    </Tooltip>
                  </Grid>
                )}

                {index > 0 && !disabled && (
                  <Grid item xs={1} className={classes.buttonRemoveContainer}>
                    <Tooltip title="Excluir serviço" placement="right-end">
                      <Grid item style={{ justifyContent: 'center', alignContent: 'center' }}>
                        <IconButton
                          onClick={(e) => {
                            arrayHelpers.remove(index);
                          }}
                        >
                          <MdHighlightOff size={18} />
                        </IconButton>
                      </Grid>
                    </Tooltip>
                  </Grid>
                )}
              </Fragment>
            );
          })
        }
      </FieldArray>

      {!limitarServicos && !disabled
        ? servicos.length < 20 && (
            <Grid item xs={12} sm={12} md={6} lg={6} xl={6} className={classes.buttonAdicionarCategoria}>
              <AddItemButton
                onClick={() => {
                  handleAdicionarServico(servicos);
                }}
              >
                Adicionar serviço
              </AddItemButton>
            </Grid>
          )
        : null}

      {indexServicoSelecionado !== undefined && (
        <RetencaoAliquotaModal
          modalRetencaoAliquota={modalRetencaoAliquota}
          setModalRetencaoAliquota={setModalRetencaoAliquota}
          onSubmit={handlerSubmitRetencaoAliquota}
          itemServico={servicos[indexServicoSelecionado]}
        />
      )}

      <Grid item xs={12}>
        <Divider style={{ backgroundColor: 'rgba(0, 0, 0, 0.50)' }} />
      </Grid>
    </>
  );
};

export default Servicos;
